import React from 'react'

const Header = () => {
  return (
    <header>
      <h1>Accessing Someone's PC...</h1>
      <h2>Pokémon Go Search String Builder</h2>
    </header>
  )
}

export default Header;
